import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import * as Yup from "yup";
import {
  COMPANY_FETCH_URL,
  HQVIEW_URL,

} from "../../../configs/constants";
import Table from "components/Table";
import Filter from "@Components/Filter";
import { useNotifyContext } from "components/Notify";



let model = [
  { id: "worker_id", label: "Worker ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "supervisor", label: "Supervisor", type: "string" },
  { id: "worker_group", label: "Worker Group", type: "string" },
  { id: "zone", label: "Zone", type: "string" },
  { id: "region", label: "Region", type: "string" },
  { id: "estate", label: "Estate", type: "string" },
  { id: "date", label: "Date", type: "date" },
  { id: "clock_in", label: "Today Clock In Time", type: "time" },
  { id: "clock_out", label: "Today Clock Out Time", type: "time" },
  { id: "status", label: "Status", type: "string" },
  { id: "remarks", label: "Attendance Type", type: "string" },

];



const HqViewReport = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);
  const setNotify = useNotifyContext();


  const details = useLocation();
  const URLS = {
    ATTENDANCE_LOG: "report/attendance",
  };
  const today = new Date();
  today.setDate(today.getDate() - 1);
  const options = { timeZone: 'Asia/Kuala_Lumpur' };
  let date = today.toLocaleDateString('en-GB', options);
  date = date.split('/').reverse().join('-');


  const getFormDate = (e) => {
    setSelectedFormDate(e);
  };
  const getToDate = (e) => {
    setSelectedToDate(e);
  };

  const filterFields = [

    {
      type: "datepicker",
      label: "From Date",
      name: "from",
      maxDate: selectedtoDate,
      getValue: getFormDate,
      required: true

    },
    {
      type: "datepicker",
      label: "To Date",
      name: "to",
      minDate: selectedFormDate,
      getValue: getToDate,
      required: true

    },



    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      paginated: true,
      required: true,


    },








  ];



  const validationSchema = Yup.object({
    from: Yup.date().required("Date is required").nullable().typeError("Invalid From Last Login Date"),
    to: Yup.date().required("Date is required").nullable().typeError("Invalid To Last Login Date"),
    company: Yup.string().required("Company is required").nullable().typeError("Company is required"),



  });
  const filterInitialValues = {
    from: date,
    to: date,

  };
  let filters = {};
  if ("searchParams" in details) {
    if (details.searchParams.from.dateForAPI) {
      filters["from"] = details.searchParams.from.dateForAPI;
    }
    if (details.searchParams.to.dateForAPI) {
      filters["to"] = details.searchParams.to.dateForAPI;
    }

  }

  const onFilterRequest = (values) => {
    const fromDate = new Date(values.from);
    const toDate = new Date(values.to);

    if (fromDate.getMonth() !== toDate.getMonth()) {
      setNotify({
        isOpen: true,
        message: "Date should be from the same month.",
        type: "error",
      });
      return;
    }

    const diffInDays = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

   
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }

  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
        validationSchema={validationSchema}
        noSearchButton
        generateReport={true}
        onClear={clearFilter}



      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >


      </div>

      {filtersApplied ? (

        <Table
          proxyURL={HQVIEW_URL}
          model={model}
          filterValues={filterValues}
          excelExport={{ fileName: "HQReport" }}
          pdfExport={{ fileName: "HQReport" }}
          noFilter
          noAddButton
          disableLabelDisplayedRows = {true}
          tableBodyDisable={true}
          paginationDisable={true}
        />
      ) : (

        <Table
          proxyURL={null}
          model={model}
          filterValues={filterValues}
          disablePdfExport={true}
          disableExcelExport={true}
          noFilter
          noAddButton
          disableLabelDisplayedRows = {true}
          tableBodyDisable={true}
          paginationDisable={true}


        



        />
      )}




    </>
  );


};
export default HqViewReport;
